import {theme} from '@chakra-ui/react'

export default {
  fonts: {
    body: `Inter, ${theme.fonts.body}`,
    heading: `Inter, ${theme.fonts.heading}`,
  },
} as const
